import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateSubFamily } from 'services/api/requests/requests';
import { mapErrorToToastProps } from 'utils/forms/mapErrorToToastProps';

import { familyMessages } from '../variables/familyMessages';
export const useUpdateSubFamily = (body, id) => {
	const queryClient = useQueryClient();
	const toast = useToast();

	return useMutation(() => updateSubFamily(body, id), {
		onSuccess: () => {
			queryClient.invalidateQueries(['subfamily']);
			queryClient.invalidateQueries(['subfamily-list']);
			queryClient.invalidateQueries(['subfamily-list-with-products']);

			queryClient.refetchQueries(['subfamily']);
			queryClient.refetchQueries(['subfamily-list']);
			queryClient.refetchQueries(['subfamily-list-with-products']);

			toast({
				title: familyMessages.MSG_SUBFAMILY_UPDATED_SUCCESS,
				description: familyMessages.MSG_SUBFAMILY_UPDATED_SUCCESS,
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any, variables, context) => {
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				familyMessages.MSG_SUBFAMILY_UPDATE_ERROR
			);
			toastErrors?.forEach(element => toast(element));
		},
	});
};
